import { useContext } from "react"
import { useParams } from 'react-router-dom'

import { Field } from "formik"

import _ from "lodash"

// Ctx
import { FormContext } from "../../context/formContext"
import { InputSwitch } from "primereact/inputswitch"
import styles from "../../styles/Form.module.css"
import fieldVisibility from "../../helpers/fieldVisibility"
import { useEffect } from "react"


function RegularFieldOutput(props) {
  const { field, isRequired, block, index } = props
  const { type } = useParams()
  const isEnterprise = type === 'enterprise'

  const form = useContext(FormContext)

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  let visibility = fieldVisibility(field.field_visibility)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!_.isEmpty(form)) {
    if (form?.editMode) {
      visibility = "none"
    }
  }

  if (!isEnterprise) {
    visibility = "none"
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visibility
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => {
            return (
              <>
                <InputSwitch
                  disabled={isDisabled}
                  inputId={field.field_name}
                  name={formikField.name}
                  id={field.field_name}
                  value={formikField.value}
                  onChange={formikField.onChange}
                  checked={formikField.value}
                />
                {meta.touched && meta.error && (
                  <div className={styles.errFieldMsg}>{meta.error}</div>
                )}
              </>
            )
          }}
        </Field>
      </div>
    </div>
  )
}

export default function TypeInputSwitch(props) {
  const checkIfRequired = () => {
    try {
      return JSON.parse(props.field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  switch (props.type) {
    case "regular-field":
      const regFieldProps = {
        field: props.field,
        isRequired,
        block: props.block,
        index: props.index,
      }
      return <RegularFieldOutput {...regFieldProps} />
    default:
      return null
  }
}